import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GradientBackground from '../components/GradientBackground';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const Imprint: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Reset scroll position when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <>
      <GradientBackground backgroundIndex={0} />
      <div style={{
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden',
      }}>
        {/* Navigation */}
        <Navigation />

        {/* Imprint Content */}
        <section style={{
          minHeight: '100vh',
          padding: '80px 24px',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(20px)',
          position: 'relative',
        }}>
          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
          }}>
            {/* Back Button */}
            <button
              onClick={handleBackToHome}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '16px',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginBottom: '40px',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              }}
            >
              {t('common.backToHome')}
            </button>

            {/* Imprint Content */}
            <div style={{
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
              borderRadius: '24px',
              padding: '48px',
              border: '1px solid rgba(255, 255, 255, 0.12)',
              backdropFilter: 'blur(20px)',
            }}>
              <h1 style={{
                fontSize: '36px',
                fontWeight: '600',
                color: 'white',
                marginBottom: '24px',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
                textAlign: 'center',
              }}>
                {t('imprint.title')}
              </h1>

              <div style={{
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.7',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
              }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', color: 'white', marginBottom: '16px', marginTop: '32px' }}>
                  {t('imprint.sections.name.title')}
                </h2>
                <p style={{ marginBottom: '16px' }}>
                  {t('imprint.sections.name.text')}
                </p>

                <h2 style={{ fontSize: '24px', fontWeight: '600', color: 'white', marginBottom: '16px', marginTop: '32px' }}>
                  {t('imprint.sections.contact.title')}
                </h2>
                <p style={{ marginBottom: '16px' }}>
                  <a 
                    href={`mailto:${t('imprint.sections.contact.email')}`}
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                    }}
                  >
                    {t('imprint.sections.contact.email')}
                  </a>
                </p>

                <h2 style={{ fontSize: '24px', fontWeight: '600', color: 'white', marginBottom: '16px', marginTop: '32px' }}>
                  {t('imprint.sections.address.title')}
                </h2>
                <p style={{ marginBottom: '16px' }} dangerouslySetInnerHTML={{ __html: t('imprint.sections.address.text') }} />
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default Imprint;
